const defaultAdminRedirect = ({ needsOrg }) =>
  needsOrg ? "/welcome" : "/dashboard"

export const requiresAuthGuard = {
  requiresAuth: true,
}

export const requiresOrganizationGuard = {
  ...requiresAuthGuard,
  requiresOrg: true,
}

export const createGa4Guard = (featureFlag) => ({
  ...requiresOrganizationGuard,
  featureFlag,
})

const baseAdminGuard = {
  ...requiresAuthGuard,
  requiresOrg: true,
  allowedRoles: ["admin"],
  redirectUnauthorized: defaultAdminRedirect,
}

export const createAdminGuard = (overrides = {}) => ({
  ...baseAdminGuard,
  ...overrides,
})

export const adminGuard = createAdminGuard()
